var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-submenu',{ref:"subMenu",attrs:{"index":_vm.handlePath(_vm.item.path),"popper-append-to-body":false}},[_c('template',{slot:"title"},[_c('span',[_vm._v(_vm._s(_vm.item.meta.title))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }